import styled from 'styled-components'

import breakpoints from '../../theme/breakpoints'
import ActionButton from '../ActionButton'
import Link from '../Link'

export const Container = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.6rem 0.8rem;
  width: 100%;
  height: 80px;
  border-top: 3px solid ${(props) => props.theme.colors.neonBlue};
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);

  ${breakpoints.up('tablet')} {
    box-shadow: none;
    padding: 2rem 2.4rem;
  }
`

export const DefaultLink = styled(Link)``

export const Logo = styled.img`
  width: 7.5rem;
  height: 5.2rem;

  ${breakpoints.up('tablet')} {
    width: 9rem;
    height: 6rem;
  }
`

export const Text = styled.h5`
  ${(props) => props.theme.textStyles.H5};
  font-weight: 800;
  color: ${(props) => props.theme.colors.nightRider};
  display: none;

  ${breakpoints.up('tablet')} {
    display: block;
  }
`

export const Button = styled(ActionButton)``
